"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
var swing = /*#__PURE__*/(0, _styledComponents.keyframes)(["20%{transform:rotate3d(0,0,1,15)},40%{transform:rotate3d(0,0,1,-10)},60%{transform:rotate3d(0,0,1,5)},80%{transform:rotate3d(0,0,1,-5)},to{transform:rotate3d(0,0,1,15)}"]);
var _default = exports["default"] = swing;